// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3_tqB","inputDescription":"styles_inputDescription__BszPb"};